import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

export default {
    init() {
        Vue.use(VueGoogleMaps, {
            load: {
                key: window.App.google_api,
            },
            installComponents: true,
        });
    },
};
